import createArray from './utils/createArray'
import pointsToCurve from './utils/pointsToCurve'
import toPath from './utils/toPath'
import pipe from 'crocks/helpers/pipe'
import SimplexNoise from 'simplex-noise'
import { DVMesh } from '@thi.ng/geom-voronoi'
import Polygon from 'polygon'

const calc = ({
    fn,
    fn2,
    fn3,
    fn4,
    rR,
    rp,
    r,
    s,
    q,
    scale,
    n,
    m,
    simplex,
    noiseScale,
    theta,
    rRr,
    cmp,
    steps,
    p1_r,
    p2_r,
    p3_r,
    p4_r,
}) => {
    // const t = theta < Math.PI ? theta : 2 * Math.PI - theta
    const t = theta
    // console.log('theta, t', theta, t)

    return (
        scale * simplex.noise2D(t / noiseScale, t / noiseScale) +
        cmp(rR * fn(theta * p1_r), rp * fn2(theta * p2_r)) +
        cmp(rR * fn3(theta * p3_r), rp * fn4(theta * p4_r)) +
        // cmp(rR * fn2(theta), 0) +
        // rRr * fn(theta * s) +
        // rRr * fn2((theta * q) / r) -
        // rR * fn(theta * r) +
        0
    )
}

const generate = ({ steps, ...props }) =>
    pipe(
        (i) => ((2 * Math.PI) / steps) * i,
        (theta) => [
            calc({
                fn: (a) => props.m * Math.pow(Math.cos(a), props.p1),
                fn2: (a) => props.m * Math.pow(Math.cos(a), props.p2),
                fn3: (a) => props.m * Math.pow(Math.cos(a), props.p3),
                fn4: (a) => props.m * Math.pow(Math.cos(a), props.p4),
                cmp: (a, b) => a + b,
                theta,
                steps,
                ...props,
            }),
            calc({
                fn: (a) => props.m * Math.pow(Math.sin(a), props.p1),
                fn2: (a) => props.m * Math.pow(Math.sin(a), props.p2),
                fn3: (a) => props.m * Math.pow(Math.sin(a), props.p3),
                fn4: (a) => props.m * Math.pow(Math.sin(a), props.p4),
                cmp: (a, b) => a - b,
                theta,
                steps,
                ...props,
            }),
        ]
    )

const generateBorder = (steps) =>
    createArray(
        pipe(
            (i) => [600 - (1200 / steps) * i, (600 / steps) * i],
            ([x, y]) => [
                // [-0, step],
                // [0, step],
                // [step, -0],
                // [step, 0],
                [x, y],
                [x, -y],
            ]
        ),
        steps
    ).flat()

const createPolygons = ({ positions, cells }) =>
    cells
        .map((cell) => cell.filter((p) => p !== -1).map((p) => positions[p]))
        .map(toPath)
export default ({
    steps,
    majorRipple,
    minorRipple,
    radius,
    scale,
    q,
    m,
    n,
    noiseScale,
    min,
    max,
    min2,
    max2,
    removePoint,
    renderAsCurve,
    renderShapes,
    sizeMin,
    sizeMax,
    polyScale,
    p1,
    p2,
    p3,
    p4,
    p1_r,
    p2_r,
    p3_r,
    p4_r,
}) => {
    p4_r = [p1_r, p2_r, p3_r, p4_r].every((i) => i % 2 === 0) ? p4_r + 1 : p4_r
    p4 = [p1, p2, p3, p4].every((i) => i % 2 === 0) ? p4 + 1 : p4
    const simplex = new SimplexNoise(fxhash)
    
    const points = createArray(
        generate({
            rR: minorRipple + majorRipple,
            rRr: minorRipple + majorRipple / minorRipple,
            s: (majorRipple + minorRipple) / minorRipple,
            rp: minorRipple + radius,
            q,
            r: minorRipple,
            m,
            n,
            steps,
            scale,
            simplex,
            noiseScale,
            p1,
            p2,
            p3,
            p4,
            p1_r,
            p2_r,
            p3_r,
            p4_r,
        }),
        steps
    ).filter(
        ([x, y], i) =>
            // x > min ||
            // x < max ||
            // y > min ||
            // y < max ||
            // x > min2 ||
            // x < max2 ||
            // y > min2 ||
            // y < max2 ||
            simplex.noise3D(i / noiseScale, x / noiseScale, y / noiseScale) >
            removePoint
    )

    const mesh = new DVMesh(points.concat(generateBorder(10)))
    try {
        const result = {
            voronoi: mesh
                .voronoi()
                .map((points, i) => {
                    const p = new Polygon(points.filter((p) => p))
                    
                    return p.scale(
                        (polyScale *
                            (1 +
                                simplex.noise2D(
                                    i / noiseScale,
                                    i / noiseScale
                                ))) /
                            2
                    )
                })
                .filter((poly) => {
                    const area = Math.abs(poly.area())
                    return area > sizeMin && area < sizeMax
                })
                .map((poly) => poly.toArray())
                .filter(
                    (points, i) =>
                        !points.some(
                            ([x, y] = []) =>
                                x == undefined ||
                                y == undefined ||
                                x < min ||
                                x > max ||
                                y < min2 ||
                                y > max2
                            // simplex.noise3D(
                            //     i / noiseScale,
                            //     x / noiseScale,
                            //     y / noiseScale
                            // ) > 0.2
                        )
                )
                .map(renderAsCurve ? pointsToCurve : toPath),
            line: pointsToCurve(points),
        }
        return result
    } catch (error) {
        
        return { voronoi: [], lines: [] }
    }
}
